import BlazePager from './BlazePager';

export default BlazePager;
